'use strict';

require('./section-header.less');

angular.module('app')
    .component('sectionHeader',
        {
            transclude: true,
            template: require('./section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, DataEnvironmentService) {
                $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
                $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
                $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
            }
        })
    .component('onboardingSectionHeader',
        {
            template: require('sections/0-onboarding/onboarding.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('ownerSectionHeader',
        {
            template: require('sections/1-owner/owner.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('timeSectionHeader',
        {
            template: require('sections/2-time/time.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('basicsSectionHeader',
        {
            template: require('sections/3-basics/basics.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('ownerCompensationSectionHeader',
        {
            template: require('sections/4-owner-compensation/owner-compensation.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('vatSectionHeader',
        {
            template: require('sections/5-vat/vat.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('booksSectionHeader',
        {
            template: require('sections/6-books/books.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('missionsSectionHeader',
        {
            template: require('sections/7-missions/missions.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('shareSectionHeader',
        {
            template: require('sections/8-share/share.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('outsourceSectionHeader',
        {
            template: require('sections/outsource/outsource.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('assistSectionHeader',
        {
            template: require('sections/assist/assist.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('helpSectionHeader',
        {
            template: require('sections/help/help.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
    .component('debugSectionHeader',
        {
            template: require('sections/debug/debug.section-header.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope) {
            }
        })
;



// WEBPACK FOOTER //
// .-dna/app/components/section-headers/angular-components.js